import {withActions} from '../withActions'
import * as constants from 'santa-renderer/src/utils/constants'
import _ from 'lodash'
const layoutUtilsFactory = require('carmi-host-extensions/src/layout/layoutUtils')

const name = 'LayoutAspect'

let layoutUtils // eslint-disable-line santa/no-module-state
let compRefs // eslint-disable-line santa/no-module-state
let _logger // eslint-disable-line santa/no-module-state

const defaultModel = {
    renderingMap: {},
    pendingReLayoutMap: {},
    measureMap: {},
    layoutCounter: 0,
    isLayoutUtilsInitialized: false,
    fontLoaded: false
}

function init(aspectActions, {eventsManager, initialData, logger}) {
    _logger = logger
    compRefs = initialData.compRefs

    if (!initialData.isInSSR) {
        eventsManager.on(constants.EVENTS.COMP_RENDER_STATE_CHANGE, (compId, isRendering) => {
            aspectActions.markRender(compId, isRendering)
        })

        eventsManager.on(constants.EVENTS.FONT_LOAD, () => {
            aspectActions.setFontLoaded(true)
        })
    }
}

function triggerComponentDidLayoutRecursive(comp) {
    if (comp.componentDidLayout) {
        comp.componentDidLayout.call(comp)
    }
    if (comp.componentDidLayoutAnimations) {
        comp.componentDidLayoutAnimations.call(comp)
    }
    _.forOwn(comp.refs, triggerComponentDidLayoutRecursive)
}

const functionLibrary = {
    registerLayoutFuncForNode: (domNode, func) => {
        layoutUtils.registerLayoutFunc(domNode, func)
    },
    registerReLayoutPendingForComp: withActions((aspectActions, compId) => {
        aspectActions.markPendingReLayout(compId, true)
    }),
    triggerLayout: withActions((aspectActions, getLayoutCounter, getCurrentLayoutData, shouldRun) => {
        if (!shouldRun) {
            return
        }
        aspectActions.setRenderingMap({})
        aspectActions.setPendingReLayoutMap({})
        aspectActions.setFontLoaded(false)
        const {measureMap} = layoutUtils.runLayout(getCurrentLayoutData())
        aspectActions.setMeasureMap(measureMap)
        Promise.resolve().then(() => {
            aspectActions.setLayoutCounter(getLayoutCounter() + 1)
        })
    }),
    initLayoutUtils: withActions((aspectActions, fullLayoutData) => {
        const warmupUtils = require('warmupUtils')
        const layout = require('layout')

        layoutUtils = layoutUtilsFactory.init(fullLayoutData, {warmupUtils, layout, lodash: _}, false, _logger)
        aspectActions.setIsLayoutUtilsInitialized(true)
    }),
    triggerComponentDidLayout: layoutCounter => {
        if (layoutCounter > 0) {
            _.forEach(compRefs, triggerComponentDidLayoutRecursive)
        }
    },
    removeImage: id => layoutUtils.imageLoader.removeImage(id),
    getCustomMeasureMap: (customMeasureMap, customId) => _.get(customMeasureMap, customId)
}



export {
    name,
    defaultModel,
    init,
    functionLibrary
}
